import React from "react";
import SecondaryBtn from "../../../ui/buttons/SecondaryBtn";
import PrimaryBtn from "../../../ui/buttons/PrimaryBtn";
import classes from "./ScheduleFooter.module.css";

const ScheduleFooter = ({ texts, hasImage, isSubmitting, pendingDelete, publishDisabled, onClose, onSave }) => (

    <div className={classes.Footer}>
        <SecondaryBtn color="var(--color-primary-button)" dropClass={classes.CancelBtn} xsmall={true} onClick={onClose}>
            {texts.cancel}
        </SecondaryBtn>

        <PrimaryBtn dropClass={`${classes.PublishBtn}${publishDisabled ? ` ${classes.PublishBtnDisabled}` : ""}`} xsmall={true} onClick={() => !publishDisabled && onSave()} isBtn={!publishDisabled}>
            {isSubmitting ? texts.loadingPublishing : hasImage || pendingDelete ? texts.scheduleSave : texts.scheduleAdd}
        </PrimaryBtn>

    </div>
);

export default ScheduleFooter;
